import React, { Suspense, lazy } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import { ToastProvider } from './context/ToastContext'

const FormPage = lazy(() => import('./pages/FormPage'))
const AdminLogin = lazy(() => import('./pages/AdminLogin'))
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'))
const AdminResponses = lazy(() => import('./pages/AdminResponses'))
const SuccessPage = lazy(() => import('./pages/SuccessPage'))

function LoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-pink-50 via-cream-50 to-purple-50">
      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-6 relative">
          <div className="absolute inset-0 bg-gradient-to-r from-pink-300 to-purple-300 rounded-full animate-pulse opacity-50"></div>
          <div className="absolute inset-2 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full animate-spin border-4 border-transparent border-t-white"></div>
        </div>
        <p className="font-quicksand text-ink-600 text-lg">Loading your experience...</p>
      </div>
    </div>
  )
}

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth()

  if (loading) return <LoadingFallback />
  if (!isAuthenticated) return <Navigate to="/admin/login" replace />

  return children
}

function PublicRoute({ children }) {
  const { isAuthenticated, loading } = useAuth()

  if (loading) return <LoadingFallback />
  if (isAuthenticated) return <Navigate to="/admin" replace />

  return children
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<FormPage />} />
      <Route path="/success" element={<SuccessPage />} />
      <Route
        path="/admin/login"
        element={
          <PublicRoute>
            <AdminLogin />
          </PublicRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/responses"
        element={
          <ProtectedRoute>
            <AdminResponses />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Suspense fallback={<LoadingFallback />}>
          <AppRoutes />
        </Suspense>
      </ToastProvider>
    </AuthProvider>
  )
}

export default App